import React, { useState } from "react";
import "./DurationsFilters.css";
export default function DurationFilters({
  interval,
  handleFilterChanged,
  options,
  isAdmin
}) {
  const [disabled, setDisabled] = useState(false);

  const handleDurationFiltersChanged = (filterType, value) => {
    if (disabled) return;

    setDisabled(true);
    const now = new Date();
    let fromDate = new Date();
    let toDate = new Date();

    switch (value) {
      case "day":
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(23, 59, 59, 999);
        break;
      case "week":
        const day = now.getDay(); // 0 (Sunday) to 6 (Saturday)
        console.log(day)
        // Set fromDate to Monday of the current week
        fromDate = new Date(now);
        fromDate.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
        fromDate.setHours(0, 0, 0, 0);

        // Set toDate to Sunday of the current week
        toDate = new Date(fromDate);
        toDate.setDate(fromDate.getDate() + 6);
        toDate.setHours(23, 59, 59, 999);
        break;
      case "month":
        fromDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 1, 0, 0);
        toDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        toDate.setHours(23, 59, 59, 999);
        break;
      case "year":
        fromDate = new Date(now.getFullYear(), 0, 1, 0, 1, 0, 0);
        toDate = new Date(now.getFullYear(), 11, 31);
        toDate.setHours(23, 59, 59, 999);
        break;
      case "custom":
        break;

      case "all":
        fromDate = null;
        toDate = null;
        break;
    }

    if (value !== "custom") handleFilterChanged({
      fromDate,
      toDate,
      interval: value,
    });

    setTimeout(() => {
      setDisabled(false); // Re-enable buttons after delay
    }, 1000);
  };

  return (
    <div className="duration_selectors" style={{ fontSize: "14px" }}>
      {options.map((options, i) => (
        <button
          disabled={disabled}
          style={{
            borderLeft:
              i === 0 && interval != options.interval && "1px solid #C9C9C9",
            borderRight: interval != options.interval && "1px solid #C9C9C9",
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.6 : 1,
          }}
          className={interval === options.interval ? "active" : ""}
          onClick={() => {
            handleDurationFiltersChanged("interval", options.interval);
            if (options.cb) {
              options.cb();
            }
          }}
        >
          {options.placeholder}
        </button>
      ))}
    </div>
  );
}
